import { createGlobalStyle } from 'styled-components';
import './fonts/fonts.css';
import { ComponentClasses } from './componentClasses';
import { finspheraTypography } from './UIStyles/variables/typography';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'NunitoRegular';
    font-size: ${finspheraTypography.fontSize.medium};
  }

  a {
    text-decoration: none;
  }

  ${ComponentClasses}
`;
